import React, { useCallback, useEffect, useState } from "react";
import DistributorTable from "../../components/table/DistributorTable";
import DistributorApi from "../../utils/api/DistributorApi";
import FixedAgent from "../../utils/api/FixedAgent";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./History.module.css";

function BoughtPins() {
  const [allTransactions, setAllTransactions] = useState(null);
  const [filteredTransactions, setFilteredTransactions] =
    useState(allTransactions);
  const [searchInput, setSearchInput] = useState("");

  const token = useSelector((state) => state.userData.loginData.token);

  const accountType = useSelector(
    (state) => state.userData.loginData.account_type
  );

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await (accountType === "DISTRIBUTOR"
        ? DistributorApi
        : FixedAgent
      ).newBoughtListHistory({
        token,
      });
      setAllTransactions(response.data.sales);
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token, accountType]);

  useEffect(() => {
    const transactions = allTransactions?.data || allTransactions;
    if (searchInput === "") {
      setFilteredTransactions(transactions);
    } else {
      const filtered = transactions?.filter((customer) =>
        customer?.seller_details?.fullname
          ?.toLowerCase()
          ?.includes(searchInput?.toLocaleLowerCase())
      );
      setFilteredTransactions(filtered);
    }
  }, [searchInput, allTransactions]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);
  return (
    <div>
      <ToastContainer />

      <div className={styles.filter_wrapper}>
        <input
          type="text"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          placeholder="Search transactions"
          className={styles.filter_input}
        />
        <button className={styles.export_button}>Export</button>
      </div>
      {/* <div style={{ display: "inline" }}>
        <button
          onClick={() => setPageNumber(pageNumber - 1)}
          disabled={pageNumber === allTransactions?.from}
          style={{
            backgroundColor:
              pageNumber === allTransactions?.from ? "grey" : "#1814F3",
            color: "white",
            padding: "5px 10px",
            margin: "5px",
            border: "none",
            float: "left",
            borderRadius: "5px",
          }}
        >
          Prev
        </button>
        <button
          onClick={() => setPageNumber(pageNumber + 1)}
          disabled={pageNumber === allTransactions?.last_page}
          style={{
            backgroundColor:
              pageNumber === allTransactions?.last_page ? "grey" : "#1814F3",
            color: "white",
            padding: "5px 10px",
            margin: "5px",
            border: "none",
            float: "left",
            borderRadius: "5px",
          }}
        >
          Next
        </button>
      </div> */}
      <DistributorTable tableData={filteredTransactions} table_type={"pin"} />
    </div>
  );
}

export default BoughtPins;
